import './Task.scss';
import classNames from 'classnames';
import { ConfirmDeleteIcon } from '@ui/modals';
import { Draggable } from 'react-beautiful-dnd';
import { InitiativeScopeItem } from '../scopes';
import { MenuOutlined } from '@ant-design/icons';
import { PLACEHOLDERS_COPY } from '@sonar-software/sonar-ts-constants';
import { SonarText } from '@ui/text';
import { useAction } from '@hooks';
import { UserSelector } from '@ui/UserSelector';
import { Checkbox, Col, Row, Space } from 'antd';
import { coreActions } from '@sonar-software/sonar-core';
import React, { useCallback, useState } from 'react';
export const InitiativeTask = ({ index, task }) => {
    const [checked, setChecked] = useState(task.completed);
    const [isEditing, setIsEditing] = useState(false);
    const [taskName, setTaskName] = useState(task.name);
    const deleteTask = useAction(coreActions.requestDeleteCoreInitiativesTasksById);
    const deleteTaskLink = useAction(coreActions.requestDeleteCoreInitiativesTasksLink);
    const updateTask = useAction(coreActions.requestPatchCoreInitiativesTasksById);
    const { initiativeId, initiativeTaskId } = task;
    const startEditing = useCallback(() => {
        setIsEditing(true);
    }, []);
    const stopEditing = useCallback(() => {
        setIsEditing(false);
    }, []);
    const onChange = useCallback((updatedName) => {
        const sanitizedName = updatedName === null || updatedName === void 0 ? void 0 : updatedName.trim();
        if (!sanitizedName || sanitizedName === taskName) {
            return;
        }
        updateTask({
            initiativeId,
            name: sanitizedName,
            taskId: initiativeTaskId
        });
        setTaskName(sanitizedName);
    }, [initiativeId, initiativeTaskId, taskName, updateTask]);
    const onClickCheckbox = useCallback(() => {
        if (isEditing) {
            return;
        }
        const toggled = !checked;
        setChecked(toggled);
        updateTask({
            completed: toggled,
            initiativeId,
            taskId: initiativeTaskId
        });
    }, [checked, initiativeId, initiativeTaskId, isEditing, updateTask]);
    const onClickDelete = useCallback(() => {
        deleteTask({
            initiativeId,
            taskId: initiativeTaskId
        });
    }, [deleteTask, initiativeId, initiativeTaskId]);
    const unlinkScopeItem = (initiativeSonarObjectId, sonarObjectId) => {
        deleteTaskLink({
            initiativeId,
            initiativeSonarObjectId,
            initiativeTaskId,
            sonarObjectId
        });
    };
    const onOwnerChange = useCallback((id) => {
        updateTask({
            assignedTo: id !== null && id !== void 0 ? id : 0,
            initiativeId,
            taskId: initiativeTaskId
        });
    }, [initiativeId, initiativeTaskId, updateTask]);
    const textClasses = classNames({ 'task-complete': checked });
    return (React.createElement(Draggable, { draggableId: String(initiativeTaskId), index: index, key: initiativeTaskId }, (draggableProvided, dragSnapshot) => React.createElement("div", Object.assign({ className: classNames('task', {
            dragging: dragSnapshot.isDragging
        }), ref: draggableProvided.innerRef }, draggableProvided.draggableProps, draggableProvided.dragHandleProps),
        React.createElement(Row, { align: 'middle', gutter: 8, justify: 'space-between', wrap: false },
            React.createElement(Col, { span: isEditing ? 24 : undefined },
                React.createElement(Space, { align: 'start', onBlur: stopEditing },
                    React.createElement(MenuOutlined, null),
                    React.createElement(Checkbox, { checked: checked, onClick: onClickCheckbox }),
                    React.createElement(SonarText, { className: textClasses, editable: {
                            editing: isEditing,
                            icon: React.createElement("span", null),
                            maxLength: 255,
                            onCancel: stopEditing,
                            onChange: onChange,
                            onEnd: stopEditing
                        }, onClick: startEditing }, taskName))),
            React.createElement(Col, { className: 'task-action-area', span: isEditing ? 0 : undefined },
                React.createElement(Space, { align: 'center' },
                    React.createElement(UserSelector, { allowClear: true, avatar: true, onSingleChange: onOwnerChange, placeholder: PLACEHOLDERS_COPY.ADD_OWNER, value: task.assignedTo ? task.assignedTo : undefined }),
                    React.createElement("div", { className: 'task-icon-area' },
                        React.createElement(ConfirmDeleteIcon, { onConfirm: onClickDelete }))))),
        React.createElement("div", { className: 'task-scope' }, task.sonarObjects.map(({ itemId, sonarObjectId }) => React.createElement(InitiativeScopeItem, { initiativeId: initiativeId, itemId: itemId, key: sonarObjectId, removeAction: unlinkScopeItem, sonarObjectId: sonarObjectId }))))));
};
